import React from "react";
import "./style/QuickActionSingle.css";

function QuickActionSingle({ name, pronouns, id, action, type }) {
  return (
    <div className="quick-action-single">
      <div className="quick-action-header">
        <div className="quick-action-info">
          <h2>
            {name} <span> {pronouns}</span>
          </h2>
          <p>{id}</p>
          <p className="quick-action-action"> Action : <span>{action}</span></p>
        </div>
        <div className="quick-action-btn-cont">
          <span className="quick-action-type">{type}</span>
          <div className="quick-action-view">View</div>
        </div>
      </div>
    </div>
  );
}

export default QuickActionSingle;
